module.exports = function _identity(x) { return x; };



//////////////////
// WEBPACK FOOTER
// ./~/coact/~/ramda/src/internal/_identity.js
// module id = 1533
// module chunks = 0